export function isMembershipMissingPermissionError(status, body) {
  return status === 409 && body?.code === 'MEMBERSHIP_MISSING';
}

export async function readPermissionErrorBody(response) {
  const errorText = await response.text();
  if (!errorText) return {};
  try {
    return JSON.parse(errorText);
  } catch {
    return { message: errorText };
  }
}
